import React from 'react';
const copy = require('copy-text-to-clipboard')

class Processed1 extends React.Component {

    constructor(props) {
        super(props);

        const { match: { params } } = this.props;

        this.userName = params.userName.replace(/_/g, ' ');;
        console.log(this.userName);

        this.magiclink = `https://fivestone-cte.s3.us-east-2.amazonaws.com/Export/${params.uuid}.mp4`;
        this.shareLink = `https://thankyoulord.christomlin.com/view/${params.uuid}/${params.userName}`;
        this.inviteLink = `https://thankyoulord.christomlin.com`;

        this.shareMessage = `Check this out! ${this.shareLink}`;

        this.facebookURL = `https://www.facebook.com/sharer/sharer.php?u=${this.shareLink}`;
        this.twitterURL = `https://twitter.com/share?url=${this.shareMessage}`;

        this.nativeAPI = this.nativeAPI.bind(this);
        this.nativeShare = this.nativeShare.bind(this);
        this.nativeInvite = this.nativeInvite.bind(this);

        this.copyUrl = this.copyUrl.bind(this);
    }

    copyUrl() {
        copy(this.shareLink);
    }

    nativeAPI(subject, url) {

        if (navigator.share) {
            navigator.share({
              title: subject,
              url: url
            }).then(() => {
              console.log('Thanks for sharing!');
            })
            .catch(console.error);
        }
    }

    nativeShare() {
        this.nativeAPI(this.shareEmailSubject, this.shareLink);
    }

    nativeInvite() {
        this.nativeAPI(this.shareEmailSubject, this.inviteLink);
    }

    render() {
        return (
            <div>
                <img src="/img/texture1.png" className="backgroundfill" alt=""/>

                <div className="side-menu flex-full-middle">
                <div className="cover"></div>
                <div className="buttonflex side pro1">
                <img src="/img/7c9e5d0f857314f5e2aaf4d2bd27426a.png" className="cover-thumb pro1" alt=""/>
                <a href={this.magiclink} download="ThankYouLord.mp4">
                    <div className="next-button-con">
                        <div className="next-button">
                            <div className="nexr-button-innercon">
                                <div className="next-button-text">Download file</div>
                                <div className="next-button-arrow"><img src="/img/down-arrow.svg" alt=""/></div>
                            </div>
                        </div>
                    </div>
                </a>


                <div id='shareDesktop'>

                    <a href={this.facebookURL}
                        data-amplify-analytics-on='click'
                        data-amplify-analytics-name='click'
                        data-amplify-analytics-attrs='attr:FacebookShare'>
                        <div className="next-button-con">
                            <div className="next-button">
                                <div className="nexr-button-innercon">
                                    <div className="next-button-text">Facebook</div>
                                    <div className="next-button-arrow"><img src="/img/share.svg" alt=""/></div>
                                </div>
                            </div>
                        </div>
                    </a>

                    <a href={this.twitterURL}
                        data-amplify-analytics-on='click'
                        data-amplify-analytics-name='click'
                        data-amplify-analytics-attrs='attr:TwitterShare'>
                        <div className="next-button-con">
                            <div className="next-button">
                                <div className="nexr-button-innercon">
                                    <div className="next-button-text">Twitter</div>
                                    <div className="next-button-arrow "><img  src="/img/share.svg" alt=""/></div>
                                </div>
                            </div>
                        </div>
                    </a>

                    <div className="next-button-con" onClick={this.copyUrl} 
                        data-amplify-analytics-on='click'
                        data-amplify-analytics-name='click'
                        data-amplify-analytics-attrs='attr:CopyURL'>
                        <div className="next-button">
                            <div className="nexr-button-innercon">
                                <div className="next-button-text">Copy URL</div>
                                <div className="next-button-arrow copy"><img src="/img/copy.svg" alt=""/></div>
                            </div>
                        </div>
                    </div>
      
                </div>
                </div>

               
                </div>

                <div className="body-con">
                    <br/>
                    <div className="current-step hidden-mobile-flex">
                        <div className="line-before"></div>
                        <div className="con step-con">
                            <div className="step">
                                <img className="stepimg share" src="/img/share.svg" alt=""/>
                            </div>
                        </div>
                        <div className="line-after"></div>
                    </div>

                    <div className="video-con">
                        <video className="hero-video main" controls  preload="auto">
                            <source src={this.magiclink} type='video/mp4'/>
                        </video>
                    </div> 

                    <h1 className="main-color processed1">your video is ready to share with the world!</h1>
                    <div className="buttonflex">

<a href={this.magiclink} download="ThankYouLord.mp4" 
    data-amplify-analytics-on='click'
    data-amplify-analytics-name='click'
    data-amplify-analytics-attrs='attr:DownloadVideo'>
    <div className="next-button-con deskhidden">
        <div className="next-button">
            <div className="nexr-button-innercon">
                <div className="next-button-text">Download file</div>
                <div className="next-button-arrow"><img src="/img/down-arrow.svg" alt=""/></div>
            </div>
        </div>
    </div>
</a>

<div className="next-button-con deskhidden" >
    <div className="next-button " onClick={this.nativeShare} 
        data-amplify-analytics-on='click'
        data-amplify-analytics-name='click'
        data-amplify-analytics-attrs='attr:NativeShare'>
        <div className="nexr-button-innercon">
            <div className="next-button-text">SHARE with friends</div>
            <div className="next-button-arrow"><img src="/img/share.svg" alt=""/></div>
        </div>
    </div>
</div>

</div>
                  
                </div>
            </div>
        );
    }
}

export default Processed1;